import { useSelector } from 'react-redux';
import { accountSelectors } from '../redux/modules/account';
import { authSelectors } from '../redux/modules/auth';
import { useRef, useEffect } from 'react';
import { ServiceAuth } from './useService/useService';
import { configSelectors } from '../redux/modules/config';

/**
 * Returns the auth data needed to make most API requests.
 *
 * Note that this returns a referenced value.
 */
export default function useServiceAuth(): ServiceAuth {
  const account = useSelector(accountSelectors.selectActiveAccountId);
  const authToken = useSelector(authSelectors.selectAccessToken);
  const config = useSelector(configSelectors.selectConfigState);

  // Prevent downstream useEffects from getting triggered on an auth token change by passing a ref.
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const refServiceAuth = useRef<ServiceAuth>({ account, authToken, config });
  useEffect(() => {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    refServiceAuth.current.account = account;
    refServiceAuth.current.authToken = authToken;
  }, [account, authToken]);
  return refServiceAuth.current;
}
